import { useEffect, useState } from "react";

const FILL_DURATION = 1500;
const FADE_DURATION = 400;
const TOTAL = FILL_DURATION + FADE_DURATION;

const Preloader = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !window.sessionStorage.getItem("cg-loaded");
  });
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    const fadeT = setTimeout(() => setFade(true), FILL_DURATION);
    const offT = setTimeout(() => {
      setShow(false);
      window.sessionStorage.setItem("cg-loaded", "1");
    }, TOTAL);
    return () => {
      clearTimeout(fadeT);
      clearTimeout(offT);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="preloader"
      className={`fixed inset-0 z-[200] bg-[#0A1628] flex flex-col items-center justify-center transition-opacity duration-500 blueprint-grid ${fade ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="font-display text-[#E8721C] text-[58px] sm:text-[88px] md:text-[112px] tracking-wide leading-none">CASSIE GEE</div>
      <div className="mt-3 text-[#8A96A3] tracking-[.32em] text-[11px] md:text-[13px]">INVESTMENTS CC · EST. 2003</div>
      <div className="mt-10 w-[240px] md:w-[320px] h-[3px] bg-[#1E2D40] overflow-hidden">
        <div className="h-full bg-[#E8721C]" style={{ animation: "cg-preload 1.5s ease-out forwards" }} />
      </div>
      <style>{`@keyframes cg-preload { from { width: 0%; } to { width: 100%; } }`}</style>
    </div>
  );
};

export default Preloader;
